// eslint-disable-next-line monorepo/no-internal-import
import {AsyncPageTrackingContextProvider} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/AsyncPageTrackingContext';
import {
  AuthenticationProvider,
  NotificationProvider,
} from '@aboutyou/logic-components';
import React from 'react';
import {LegacyStateProvider} from '../bridge/SyncLegacyStateContext';

export const AppProviders: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <AsyncPageTrackingContextProvider>
      <LegacyStateProvider>
        <NotificationProvider>
          <AuthenticationProvider>{children}</AuthenticationProvider>
        </NotificationProvider>
      </LegacyStateProvider>
    </AsyncPageTrackingContextProvider>
  );
};
